"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPhoneNumber = void 0;

var _googleLibphonenumber = _interopRequireDefault(require("google-libphonenumber"));

var _loglevel = _interopRequireDefault(require("loglevel"));

var PhoneNumberUtil = _googleLibphonenumber.default.PhoneNumberUtil.getInstance();

var MODULE_NAME = 'sdk/utils/isPhoneNumber';

var logger = _loglevel.default.getLogger(MODULE_NAME);

var isPhoneNumber = function isPhoneNumber(phoneNumber) {
  var countryCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'US';
  // handle null countryCode
  var cc = countryCode || 'US';
  logger.info("".concat(MODULE_NAME, " - isPhoneNumber called"), phoneNumber, cc);

  try {
    var pn = PhoneNumberUtil.parse(phoneNumber, cc);
    return PhoneNumberUtil.isPossibleNumber(pn) && PhoneNumberUtil.isValidNumber(pn);
  } catch (err) {
    logger.debug("".concat(MODULE_NAME, " - isPhoneNumber err"), err);
    return false;
  }
};

exports.isPhoneNumber = isPhoneNumber;